import { combineReducers } from 'redux';
import auth from './auth';
import mill from './mill';
import certificate from './certificate';
import labour from './labour';
import global from './global';

export default combineReducers({ auth, mill, certificate, global, labour });
